import { buildNewUrl, getPaging } from 'features/routing';

/* The `PaginationNumberLink` class represents a link for a specific page number in a pagination component. */
class PaginationNumberLink {
  /**
   * Sets the value of the pageNumber property.
   * @param pageNumber - The pageNumber parameter is the number of the page that you want to set.
   */
  setPageNumber(pageNumber) {
    this.pageNumber = pageNumber;
  }

  /**
   * Sets the URL reference by combining the URL components and the paging segment.
   * @param urlComponents - urlComponents is an object that contains various components of a URL, such
   * as the protocol, domain, path, query parameters, etc.
   */
  setUrl(urlComponents) {
    const pagingSegment = getPaging(this.pageNumber);
    const urlSegments = { ...urlComponents, urlPaging: pagingSegment };
    this.urlReference = buildNewUrl(urlSegments);
  }

  /**
   * Returns an HTML string representing a list item with a link, including page number and URL reference.
   *
   * @returns an HTML string that represents a list item with a link. The values are being dynamically
   * generated based on the values of the properties `this.pageNumber` and `this.urlReference`.
   */
    getHtml() {
    return `<li class="nhs-c-pagination__number-container nhs-mq-pagination__number-container--extra-large" data-qa="pagination_number_container">
             <a class="nhs-c-pagination__number nhs-mq-pagination__number--extra-large" data-qa="pagination_number" data-page="${this.pageNumber}" href="${this.urlReference}" aria-label="Go to ${this.pageNumber} page">${this.pageNumber}</a>
            </li>`;
  }
}

export default PaginationNumberLink;
